import { can, type Permission } from '@atlas-control/shared';
import { redirect } from '@tanstack/react-router';
import type { Me } from './auth';

/**
 * For a route's `beforeLoad`: sends a role without the permission to /403
 * instead of rendering a page whose API calls would all be refused.
 */
export function guard(me: Me, ...permissions: Permission[]): void {
  if (!permissions.some((p) => can(me.user.role, p))) {
    throw redirect({ to: '/403' });
  }
}
